IREP.VideoTrackingv2 = (function () {
  
    
        var activityCode = (function () {
            var regex = new RegExp("[\\?&]code=([^&#]*)"),
            results = regex.exec(location.search);
            return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));


        }());
        $('video').each(function () {
            var video = $(this);
            var videoEl = video[0];
            var loggedBegin = false;
            var loggedEnd = false;
            var loggedMiddle = false;

            var log = function (viewType) {
                var url = videoEl.currentSrc;
                var isaNumber = video.attr('data-isa-number') || video.attr('isa-number');
                var data = { ViewType: viewType, Source: null, URL: url, ActivityCode: activityCode, ISANumber: isaNumber };

                IREP.callApi({ url: '/videotracker', type: 'POST', data: data });
            }

            var capture = function () {
                if (videoEl.currentTime < 5 && !loggedBegin) {

                    log(1);
                    loggedBegin = true;
                } else if (videoEl.currentTime > (videoEl.duration / 2) && !loggedMiddle) {

                    log(3);
                    loggedMiddle = true;
                } else if (videoEl.currentTime > (videoEl.duration - 5) && !loggedEnd) {

                    log(2);
                    loggedEnd = true;
                }
            }

            if (video.find('source').length > 0) {
                video.on('durationchange', capture);
                video.on('timeupdate', capture);
            }
        });
   
})();

